import { Button } from ".";
import { ReactComponent as OopsIcon } from "../assets/icons/oops.svg";
import React from "react";
import styles from "./ErrorBoundary.module.scss";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  handleReloadClick() {
    // location.reload() will not work here,
    // we need to take user away from the buggy page.
    // If user is logged in - he'll be redirected to the home page.
    window.location = "/login";
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.iconContainer}>
              <OopsIcon className={styles.icon} />
            </div>
            {/* eslint-disable-next-line */}
            <div className={styles.message}>Something went wrong</div>
            <Button
              type="button"
              title={"Reload"}
              variant="light"
              size="sm"
              onClick={this.handleReloadClick}
            />
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}
